export const USAGE_SCORE_LEGEND = [
  { label: "≥ 70%", className: "bg-green-100 text-green-800" },
  { label: "40–69%", className: "bg-amber-100 text-amber-800" },
  { label: "< 40%", className: "bg-red-100 text-red-800" },
];

const CARE_SECTOR_LABELS = {
  ndis: "NDIS",
  aged_care: "Aged care",
};

export function formatCareSector(value) {
  if (!value) {
    return "—";
  }

  return CARE_SECTOR_LABELS[value] ?? value.replace(/_/g, " ");
}

export function formatUsageSnapshotMeta(meta) {
  if (!meta) {
    return "Cross-tenant module adoption scores (last snapshot)";
  }

  const { tenants_total: total = 0, tenants_with_snapshots: withSnapshots = 0, last_computed_at: lastAt } = meta;

  if (withSnapshots === 0) {
    return `No usage snapshots yet (${total} tenants). Refresh all to populate scores.`;
  }

  const coverage = `${withSnapshots}/${total} tenants snapshotted`;
  const asOf = lastAt ? ` · Data as of ${formatUsageTimestamp(lastAt)}` : "";

  return `Cross-tenant module adoption · ${coverage}${asOf}`;
}

export function formatUsageTimestamp(value) {
  if (!value) {
    return null;
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return date.toLocaleString(undefined, {
    dateStyle: "medium",
    timeStyle: "short",
  });
}

export function getUsageScoreHeatClass(score) {
  if (score === null || score === undefined) {
    return "bg-gray-50 text-gray-400";
  }

  if (score >= 70) {
    return "bg-green-100 text-green-800";
  }

  if (score >= 40) {
    return "bg-amber-100 text-amber-800";
  }

  return "bg-red-100 text-red-800";
}

export function resolveUsageCell(score, hasSnapshot) {
  if (!hasSnapshot) {
    return {
      display: "—",
      title: "No snapshot — refresh to compute scores",
      className: "border border-dashed border-gray-200 bg-gray-50 text-gray-400",
    };
  }

  if (score === null || score === undefined) {
    return {
      display: "N/A",
      title: "Module not applicable for this tenant",
      className: "bg-gray-50 text-gray-400",
    };
  }

  return {
    display: String(score),
    title: `Adoption score: ${score}%`,
    className: getUsageScoreHeatClass(score),
  };
}

export function buildUsageHeatmapColumns(modules = {}) {
  return Object.entries(modules).map(([key, label]) => ({ key, label }));
}

export const DEFAULT_USAGE_FILTERS = {
  search: "",
  page: 1,
  perPage: 25,
};

export const buildUsageListQuery = (filters, basePath = "super-admin/usage") => {
  const params = new URLSearchParams();

  if (filters.search) {
    params.append("search", filters.search);
  }

  params.append("page", String(filters.page || 1));
  params.append("per_page", String(filters.perPage || 25));

  const query = params.toString();
  return query ? `${basePath}?${query}` : basePath;
};
